const PlanActivityLogType = {
  CrmPlan2d: 'crm_plan_2d',
  CrmPlan3d: 'crm_plan_3d',
  ServicePlan: 'service_plan',
};

export { PlanActivityLogType };
